module.exports = __webpack_public_path__ + "static/media/tournament.6ba8c91a.svg";